import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import Visibility from "@mui/icons-material/Visibility";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem, GridActionsCellItemProps } from "@mui/x-data-grid-premium";
import { TenantCatalogProductFragment } from "generated-graphql/graphql";
import { ReactElement } from "react";

/**
 * Row actions for the product catalog grid. Mirrors buildChemicalRowActions:
 * the controls follow the row's canWrite/canDelete capabilities, and Delete
 * stays focusable with `aria-disabled` so its no-permission tooltip shows.
 */
export function buildProductRowActions({
  row,
  onOpen,
  onDelete,
}: {
  row: TenantCatalogProductFragment;
  onOpen: (row: TenantCatalogProductFragment) => void;
  onDelete: (row: TenantCatalogProductFragment) => void;
}): ReactElement<GridActionsCellItemProps>[] {
  const openAction = row.canWrite ? (
    <GridActionsCellItem
      key="edit"
      label="Edit"
      icon={
        <Tooltip title="Edit" describeChild>
          <Edit />
        </Tooltip>
      }
      onClick={() => onOpen(row)}
    />
  ) : (
    <GridActionsCellItem
      key="view"
      label="View"
      icon={
        <Tooltip title="View" describeChild>
          <Visibility />
        </Tooltip>
      }
      onClick={() => onOpen(row)}
    />
  );

  const deleteAction = (
    <GridActionsCellItem
      key="delete"
      label="Delete"
      icon={
        <Tooltip
          title={row.canDelete ? "Delete" : "You do not have permission to delete this product"}
          describeChild
        >
          <Delete color={row.canDelete ? undefined : "disabled"} />
        </Tooltip>
      }
      aria-disabled={row.canDelete ? undefined : true}
      onClick={() => {
        if (row.canDelete) {
          onDelete(row);
        }
      }}
    />
  );

  return [openAction, deleteAction];
}
